import { css } from 'styled-components';

/**
 * The app's placeholder — every placeholder reads the same: selects (`Select.styles.ts`), text and
 * date inputs (`MaterialInput.styles.ts`, which the owner cell's `UserInput` and the date picker
 * build on) and, through those, the inline cells of the RMP and Control Maturity tables. Defined
 * once so a surface cannot drift (the bulk-edit bar did, at 16px full strength — CRPD-7332).
 */
export const placeholderStyle = css`
  font-size: 14px;
  font-weight: 500;
  color: ${({ theme }) => (theme.scheme === 'light' ? theme.colors.cflowerBlue : '#848D9F')} !important;
  opacity: ${({ theme }) => (theme.scheme === 'light' ? 0.6 : 1)} !important;
`;
